module.exports = function (lesson, word, popup_self) {
  var as = '';
  var play_button_visible = 'visibility:hidden';
  if (word.audio_source) {
    as = word.audio_source;
    play_button_visible = '';
  }
  if (as != '') {
    as = "https://popupchinese.com/data/".concat(lesson.id, "/mp3/vocab/").concat(as);
  }
  var df1 = '';
  var df2 = '';
  var df3 = '';
  var df4 = '';
  var df5 = '';
  if (popup_self.app.options.popup.vocab.field1 == 0) {
    df1 = 'none';
  }
  if (popup_self.app.options.popup.vocab.field2 == 0) {
    df2 = 'none';
  }
  if (popup_self.app.options.popup.vocab.field3 == 0) {
    df3 = 'none';
  }
  if (popup_self.app.options.popup.vocab.field4 == 0) {
    df4 = 'none';
  }
  if (popup_self.app.options.popup.vocab.field5 == 0) {
    df5 = 'none';
  }
  try {
    if (popup_mod.app.options.popup.display.traditional == 1) {
      s = switch_display_mode_in_string(s, 'traditional', 'simplified');
      p = switch_display_mode_in_string(p, 'traditional', 'simplified');
    }
  } catch (err) {}
  return "\n    \t<tr class=\"word\">\n    \t  <td class=\"player\" style=\"".concat(play_button_visible, "\"><img src=\"/popup/img/buttons/play_button.gif\" onclick=\"playWordAudio('").concat(as, "',this);\"></td>\n    \t  <td class=\"lesson_word_field4 field4\" style=\"display:").concat(df4, "\">").concat(word.field4, "</td>\n    \t  <td class=\"lesson_word_field3 field3\" style=\"display:").concat(df3, "\">").concat(word.field3, "</td>\n    \t  <td class=\"lesson_word_field1 field1\" style=\"display:").concat(df1, "\">").concat(word.field1, "</td>\n    \t  <td class=\"lesson_word_field2 field2\" style=\"display:").concat(df2, "\">").concat(word.field2, "</td>\n    \t  <td class=\"lesson_word_field5 field5\" style=\"display:").concat(df5, "\">").concat(word.field5, "</td>\n    \t</tr>\n    ");
};